'use client'

import UiNotice from '@/components/ui/UiNotice.jsx'
import UiPageHead from '@/components/ui/UiPageHead.jsx'
import { asset, config } from '@/config'

import styles from './Services.module.css'

/*
 * 客服 —— 照舊站 resources/views/www/services.blade.php（Services/index）。
 *
 * 四張卡、順序與文案逐字照抄:LINE 客服 / Telegram 客服 / 線上客服 / 香港會員專屬（WhatsApp）。
 * 網址集中在 src/config.js（頁尾的浮動客服鈕用的是同一組），不要在這裡再寫死一次。
 *
 * 舊站每張卡左邊是一張 QR Code 圖（images/service/*.png.webp）。那批圖跟著
 * public/assets 走，不在這個 repo 裡（sync_uploads.php 同步進來），所以圖載不到時
 * 用 onError 把它藏起來 —— 手機掃 QR 是附加做法，右邊的按鈕才是主要入口，
 * 少一張圖不影響客人聯絡得到客服。
 */

// gr66:三張卡、順序與文案照 GR 舊站 views/www/service.php（LINE / 24 小時線上客服 / Telegram）。
// QR 圖 Owner 2026-10-22「客服頁要有 QR 碼」補上:images/service/qr-*.webp 是照 config.js 那三個網址現產的
//（舊 WP 的 Telegram QR 是 t.me/gr7701，跟現在的 gr66net_bot 不同，不能沿用），電腦掃手機用;手機點按鈕就好。
// ⚠ 這三個網址若改了（config.js 或 brand env），QR 要重產，不然掃到舊連結。
const CARDS = [
  { href: config.lineUrl, name: 'LINE 客服', desc: '加官方帳號對話，可傳截圖與單號', go: '加入', img: 'images/service/qr-line.webp', alt: 'LINE 客服 QR Code' },
  { href: config.supportUrl, name: '24 小時線上客服', desc: '網頁即時對話，全天有人回', go: '聯絡', img: 'images/service/qr-chat.webp', alt: '線上客服 QR Code' },
  { href: config.telegramUrl, name: 'Telegram', desc: '帳號 @gr66net_bot，操作問題可直接問', go: '開啟', img: 'images/service/qr-telegram.webp', alt: 'Telegram 客服 QR Code' },
]

export default function Services() {
  return (
    <main className={styles.main}>
      <UiPageHead title="24H 線上客服" en="SERVICE" lead="點下方按鈕聯繫客服，全天候有專人回覆。" />

      <div className={styles.grid}>
        {CARDS.map((card) => (
          <a key={card.name} className={styles.card} href={card.href}>
            {card.img ? <img className={styles.qr} src={asset(card.img)} alt={card.alt} onError={(e) => { e.currentTarget.style.display = 'none' }} /> : null}

            <div className={styles.text}>
              <div className={styles.name}>{card.name}</div>
              <div className={styles.desc}>{card.desc}</div>
            </div>

            <span className={styles.go}>{card.go}</span>
          </a>
        ))}
      </div>

      <UiNotice
        title="聯繫前請留意"
        items={['客服不會主動索取您的登入密碼，請勿提供給任何人。', '詢問存提款進度時，請一併提供帳號與交易時間，處理較快。']}
      />
    </main>
  )
}
